module.exports ={
	SET_SELECTED_VIEW:'SET_SELECTED_VIEW',
	GOTO_VIEW:'GOTO_VIEW',
	GOTO_RIGHT_VIEW:'GOTO_RIGHT_VIEW',
	GOTO_LEFT_VIEW:'GOTO_LEFT_VIEW'
}